import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography, Link, Stack, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import useMediaQuery from '@mui/material/useMediaQuery';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
    const greenColor = '#1cc2a3';

    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <Box component="footer" sx={{ bgcolor: '#2c2e34', color: 'white', pt: 8, position: 'relative', }}>
            <Container sx={{ px: 6 }}>
                <Grid container rowSpacing={5} columnSpacing={{ xs: 2, md: 4 }} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                    {/* Column 1: About */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>
                                About Us
                            </Typography>
                            <Box sx={{ width: 40, height: 3, bgcolor: greenColor }} />
                        </Box>
                        <Typography sx={{ color: '#aaa', lineHeight: 1.8, pr: 2, width: { xs: 350, md: 400 }, fontSize: '16px', }}>
                            One of the most prestigious and recognized manufacturers, exporters, supplier of diverse varieties of natural stones. Our hot products which we manufacture on a very large scale.
                        </Typography>
                    </Grid>

                    {/* Column 2: Quick Links */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>
                                Quick Links
                            </Typography>
                            <Box sx={{ width: 40, height: 3, bgcolor: greenColor }} />
                        </Box>
                        <Stack spacing={1}>
                            {[
                                { name: 'Home', path: '/' },
                                { name: 'About Us', path: '/about-us' },
                                { name: 'Gallery', path: '/gallery' },
                                { name: 'Contact Us', path: '/contact-us' }
                            ].map((item) => (
                                <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <KeyboardArrowRightIcon sx={{ color: greenColor, fontSize: '1.2rem', mr: 0.5 }} />
                                    <Link
                                        component={RouterLink}
                                        to={item.path}
                                        underline="none"
                                        sx={{
                                            color: '#aaa',
                                            '&:hover': { color: greenColor },
                                            transition: '0.3s',
                                            fontSize: '0.95rem'
                                        }}
                                    >
                                        {item.name}
                                    </Link>
                                </Box>
                            ))}
                        </Stack>
                    </Grid>

                    {/* Column 3: Contact Info */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>
                                Contact Us
                            </Typography>
                            <Box sx={{ width: 40, height: 3, bgcolor: greenColor }} />
                        </Box>
                        <Stack spacing={2} sx={{ color: '#aaa', fontSize: '16px', lineHeight: 1.7 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <KeyboardArrowRightIcon sx={{ color: greenColor, fontSize: '1.2rem', mr: 0.5, mt: 0.3 }} />
                                <Box>
                                    <Link href="tel:+919845374571" underline="none" sx={{ color: '#aaa', '&:hover': { color: greenColor } }}>
                                        98453 74571
                                    </Link>
                                    {' / '}
                                    <Link href="tel:+916366663480" underline="none" sx={{ color: '#aaa', '&:hover': { color: greenColor } }}>
                                        63666 63480
                                    </Link>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <KeyboardArrowRightIcon sx={{ color: greenColor, fontSize: '1.2rem', mr: 0.5, mt: 0.3 }} />
                                <Link
                                    href="mailto:info@4mhenterprises.com"
                                    underline="none"
                                    sx={{ color: '#aaa', '&:hover': { color: greenColor }, cursor: 'pointer' }}
                                >
                                    info@4mhenterprises.com
                                </Link>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <KeyboardArrowRightIcon sx={{ color: greenColor, fontSize: '1.2rem', mr: 0.5, mt: 0.3 }} />
                                <Typography variant="body2" sx={{ color: '#aaa', width: { xs: '100%', md: 300 }, lineHeight: 1.7 }}>
                                    Address : Ground Floor, No.44, C1, 4th Main Road, Jaraganahalli, Ilyas Nagar, J.P. Nagar Post, Bangalore - 560078, Karnataka, India
                                </Typography>
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
            {/* Copyright */}
            <Box sx={{ mt: 6, p: '20px 0', textAlign: 'center', backgroundColor: "#212121", px: 2 }}>
                <Typography sx={{ color: '#ddd', fontSize: '1.2rem', lineHeight: 1.7 }}>
                    Copyright © 2022 4MH Enterprises. All Rights Reserved.
                </Typography>
            </Box>

            {/* Scroll to Top Button */}
            <IconButton
                onClick={scrollToTop}
                sx={{
                    position: 'fixed',
                    bottom: "50px",
                    right: "32px",
                    bgcolor: "#25d5b2",
                    color: 'white',
                    '&:hover': { bgcolor: '#17a086' },
                    width: 45,
                    height: 45,
                    linHeight: 1.2,
                    borderRadius: 1,
                    zIndex: 9999,
                    boxShadow: 3,
                    display: isVisible ? 'flex' : 'none', // Toggle visibility
                }}
            >
                <KeyboardArrowUpIcon />
            </IconButton>

            {/* WhatsApp Button */}
            <IconButton
                onClick={() => window.open('https://wa.me/919845374571', '_blank')}
                sx={{
                    position: 'fixed',
                    bottom: "15px",
                    right: "15px",
                    bgcolor: '#25D366',
                    color: 'white',
                    '&:hover': { bgcolor: '#1ebe57' },
                    width: 45,
                    height: 45,
                    borderRadius: 1,
                    zIndex: 9999,
                    boxShadow: 3,
                }}
            >
                <WhatsAppIcon />
            </IconButton>
        </Box>
    );
};

export default Footer;
